import { z } from 'zod'

export const FoodType = z.enum([
  'FRUITS',
  'CARBOHYDRATES',
  'VEGETABLES',
  'BEANS_AND_OILSEEDS',
  'DAIRY_PRODUCTS',
  'PROTEIN',
  'OIL_AND_FAT',
  'SUGAR_AND_CANDIES',
  'OTHERS'
])
export type FoodType = z.infer<typeof FoodType>
